import { JSXElement, mergeProps, Show } from 'solid-js';
import AdminPortalErrorBoundary from '~/components/ErrorBoundaries/AdminPortalErrorBoundary.tsx';
import {
  ScalekitWatermark,
  useScalekitWatermarkVisibility
} from '~/components/ScalekitWatermark';

type CustomerPortalSSOBaseProps = {
  children: JSXElement;
};

export default function AdminPortalBase(
  props: CustomerPortalSSOBaseProps
): JSXElement {
  const merged = mergeProps({}, props);
  const { shouldShowWatermark } = useScalekitWatermarkVisibility();
  return (
    <AdminPortalErrorBoundary>
      <div class={`w-full min-h-screen bg-bg-disabled`}>
        {merged.children}
        <Show when={shouldShowWatermark()}>
          <ScalekitWatermark class="mx-auto w-10/12 xl:w-8/12 border border-border-muted border-t-0 " />
        </Show>
      </div>
    </AdminPortalErrorBoundary>
  );
}
